import { ViewModelForm, ViewModelServiceContext } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useMemo, useState } from "react";
import cx from 'classnames'
import metadata from './TWIABuildingConstructionAccordion.metadata.json5'
import { Flex } from '@jutro/layout'
import { Chevron, Icon } from '@jutro/components';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import { TranslatorContext } from "@jutro/locale";
import messages from './TWIABuildingConstructionAccordion.messages.js';

function TWIABuildingConstructionAccordion(props) {
    const { handleEditLinkClick, wizardStep, isConfirmationStep } = props;
    const translator = useContext(TranslatorContext)
    const viewModelService = useContext(ViewModelServiceContext);
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [building, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);
    const [constructionType, setConstructionType] = useState()
    const [riskItemType, setRiskItemType] = useState()

    const getConstructionSummarySubHeading_TWIA = useMemo(() => {
        const riskItemTypeTWIA = (_.get(building, 'riskItemType_TWIA'))?.value || "N/A"
        const riskItem = translator({
            id: riskItemTypeTWIA.name || "N/A",
            defaultMessage: riskItemTypeTWIA.name || "N/A"
        })
        setRiskItemType(riskItem)
        let construction;
        const constructionTypeTWIA = (_.get(building, 'construction_TWIA.constructionType_TWIA'))?.value || "N/A"
        if (constructionTypeTWIA !== "N/A") {
            construction = translator({
                id: constructionTypeTWIA.name || "N/A",
                defaultMessage: constructionTypeTWIA.name || "N/A"
            })
            setConstructionType(construction)
        }
        return construction || riskItem;
    }, []);

    const constructionHeader = useCallback((isOpen) => {
        return (
            <Flex justifyContent="between" className={styles.fullWidth}>
                <Icon
                    icon="gw-build"
                    id="wrench"
                    size="medium"
                />
                <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.constructionHeading)}</div>
                <div className={cx(styles.heading, styles.flexOneThird)}>{getConstructionSummarySubHeading_TWIA}</div>
                <Chevron className={styles.chevronMargin} isOpen={isOpen} />
            </Flex>
        )
    }, [])

    const getRoofType = useCallback(() => {
        const roofType = _.get(building, 'construction_TWIA.roofType_TWIA')?.value || "N/A"
        let rooType_TWIA
        if (roofType !== "N/A") {
            rooType_TWIA = translator({
                id: roofType.name,
                defaultMessage: roofType.name
            })
        }
        return rooType_TWIA
    }, [building])

    const editConstruction = useCallback(() => {
        if (wizardStep === -1 || isConfirmationStep) {
            handleEditLinkClick(2, false, undefined, undefined, building)
        } else {
            handleEditLinkClick(2, undefined, undefined, undefined, building)
        }
    }, [])

    const resolvers = {
        resolveCallbackMap: {
            constructionHeader,
            editConstruction
        },
        resolveClassNameMap: styles
    }

    const overrideProps = {
        constructionType: {
            value: constructionType || 'N/A'
        },
        roofType: {
            value: getRoofType() || 'N/A'
        },
        numberOfStories: {
            value: _.get(building, 'construction_TWIA.numStories_TWIA')?.value || "N/A"
        },
        totalArea: {
            value: _.get(building, 'construction_TWIA.totalArea_TWIA')?.value || "N/A"
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={building}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIABuildingConstructionAccordion
